(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  var arrowImgPath = "/images/change/";

  /**
   * Displays the data table view on the right hand side of the map
   * that shows data for the currently selected region
   */
  ns.SelectedRegionTableView = Backbone.View.extend({
    el: "#selected-region-table-container",
    templateSelector: "#selected-region-table-template",
    name: "SelectedRegionTableView",

    arrowUrls: {
      up: {
        bad: arrowImgPath + "change-red-up.png",
        good: arrowImgPath + "change-green-up.png",
        neutral: arrowImgPath + "change-gray-up.png"
      },
      down: {
        bad: arrowImgPath + "change-red-down.png",
        good: arrowImgPath + "change-green-down.png",
        neutral: arrowImgPath + "change-gray-down.png"
      },
      noChange: arrowImgPath + "no-change.png"
    },

    initialize: function(options) {
      this.initialRenderPromise = $.Deferred();

      _.bindAll(this, "render", "loadTemplate");

      this.dataResponseModel = options.dataResponseModel;

      this.model.on("change", this.render);

      // Preload all arrow images
      this.preloadArrows(this.arrowUrls);
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    preloadArrows: function(obj) {
      var self = this;

      _.each(obj, function(entry) {
        // If it's a URL, preload it
        if (typeof entry === "string") {
          var img = new Image();
          img.src = entry;
        }
        // If it's an object, assume it will contain paths and recurse
        if (typeof entry === "object") {
          self.preloadArrows(entry);
        }
      });
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    getCurrentFips: function() {
      return this.model.get("selectedFips");
    },

    /**
     * Renders the table area
     */
    render: function() {
      var self = this;

      this.loadTemplate();

      var fips = this.getCurrentFips();

      // If there's no selected fips, hide the current view
      if (!fips || fips === "a") {
        self.$el.hide();
        self.initialRenderPromise.resolve();
        return;
      }

      // Get the data to display
      $.when(this.dataResponseModel.getDataResponse()).done(function() {
        // Gather the properties necessary to render the template
        var response = self.dataResponseModel.get("response");

        if (!response || !response.locationsByFips) {
          // no data to display
          return;
        }
        
        var currentLocation = response.locationsByFips[fips];

        if (!currentLocation || currentLocation.isUninhabited) {
          if (!currentLocation) {
            console.warn("Data response missing location for fips: ", fips);
          }
          
          self.$el.hide();
          self.initialRenderPromise.resolve();
          return;
        }

        // Data summary -- Pull it from the global selectors instance.
        var getSummaryFunc =
          ccc.viz.map.views.instances.SelectorsView
            .getDataSummaryByPropertyNames;
        var summary1 = response.currentDistributionName;
        if (_.str.isBlank(summary1)) {
          summary1 = response.indicatorGroupName;
        }
        var summary2 = getSummaryFunc(["timeFrameId", "dataFormatId"]);

        var templateData = {
          dataSummary1: summary1,
          dataSummary2: summary2,
          previousTfName: response.previousTimeFrameName,
          data: []
        };

        // Extract data for the current FIPS
        var dataForFips = response.tableDataByFips[fips];
        _.each(dataForFips, function(data) {
          var d = {};

          // Characteristic name for text, if available
          if (data.characteristicId) {
            d.text = response.characteristicsById[data.characteristicId].name;

            // Highlight the cell when it's the currently selected characteristic
            if (data.characteristicId === self.model.get("characteristicId")) {
              d.isActive = true;
            }
          }
          // Otherwise, show the selected location name
          else {
            d.text = response.locationsByFips[fips].name;

            // There's only 1 data row in this table, so highlight it (unless it's the NYC table)
            if (fips !== ccc.viz.util.Fips.NYC) {
              d.isActive = true;
            }
          }

          d.displayValue = data.displayValue;
          d.changeDisplayValue = data.changeDisplayValue;

          // Figure out which image to show
          var change = parseFloat(data.changeValue);
          var upDown = "noChange";
          var altText = "No change";
          if (change > 0) {
            upDown = "up";
            altText = "Higher";
          }
          else if (change < 0) {
            upDown = "down";
            altText = "Lower";
          }

          var goodBad = "neutral";
          if (
            (response.largerValuesAre === "better" && change > 0) ||
            (response.largerValuesAre === "worse" && change < 0)
          ) {
            goodBad = "good";
            altText += " (Better)";
          }
          else if (
            (response.largerValuesAre === "worse" && change > 0) ||
            (response.largerValuesAre === "better" && change < 0)
          ) {
            goodBad = "bad";
            altText += " (Worse)";
          }

          d.changeAltText = altText;
          d.changeImgUrl =
            upDown === "noChange"
              ? self.arrowUrls.noChange
              : self.arrowUrls[upDown][goodBad];

          // Don't display any image at all if there's no change data available
          if (data.changeValue == null) {
            d.changeImgUrl = null;
          }

          templateData.data.push(d);
        });

        // Render the contents
        var height = self.$el.outerHeight(true);
        if (height > 0) {
          self.$el.height(self.$el.outerHeight(true));
        }
        self.$el.html(self.template(templateData));

        // Ensure we're visible / animate the transition
        self.$el
          .height("auto")
          .hide()
          .fadeIn(function() {
            self.initialRenderPromise.resolve();
          });
      });
    }
  });
})(jQuery, _);
